import {useLocale} from "../context/LocaleContext";
import React from "react";
import { Link } from "react-router-dom";
import pages from "../data/legalPages.json";

export default function LegalPage({ path }) {
 const {t: translate, locale: currentLocale}=useLocale();

  const page = pages[path];
  return <article className="mx-auto max-w-3xl px-6 py-12" style={{ color: "var(--sy-text)" }}>
    <h1 className="font-display text-3xl sy-gold-text">{translate(page.title)}</h1>
    {currentLocale!=="tr"&&<p className="mt-4 text-sm">{translate("Özgün kaynak metni Türkçe olarak korunur.")}</p>}
    {page.sections.map(section => <section key={section.heading} className="mt-8">
      <h2 className="text-xl font-semibold">{translate(section.heading)}</h2>
      <p lang="tr" dir="ltr" className="mt-3 leading-relaxed" style={{ color: "var(--sy-text-dim)" }}>{section.text}</p>
    </section>)}
    <nav aria-label={translate("Hukuki bilgiler")} className="mt-10 flex flex-wrap gap-5 underline">
      <Link to="/gizlilik">{translate("Gizlilik Politikası")}</Link><Link to="/veri-silme">{translate("Veri Silme")}</Link>
      <Link to="/kullanim-kosullari">{translate("Kullanım Koşulları")}</Link><a href="mailto:info@sayyadi.com.tr">{translate("İletişim")}</a>
    </nav>
  </article>;
}
